import { camelizeKeys } from 'humps';
import { postRPC } from '@namespace/helpers';

export const getEventsBySports = ({ params }) => {
  return postRPC('frontend/event/get_by_sport', params).then(camelizeKeys);
};
